export default __webpack_public_path__ + "static/timewarp-gui-bd9b2b75710472b2dab069b7f257795a.png";